type Props = { value: string };

export const ViewTitle: React.VFC<Props> = ({ value }) => {
  return <div className="text-xl text-darkblue_100 font-bold">{value}</div>;
};
